module.exports = __webpack_public_path__ + "img/portrait.885605ea.png";